import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, Download, Loader2, FileSpreadsheet } from "lucide-react";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ImportRow = ({ entityKey, label }) => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const doImport = async (file) => {
    if (!file) return;
    setBusy(true); setResult(null);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await api.post(`/kg/import/${entityKey}`, fd);
      setResult(res.data);
      toast.success(`${label}: ${res.data.created} created, ${res.data.updated} updated`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Import failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 flex flex-wrap items-center gap-3" data-testid={`import-row-${entityKey}`}>
      <FileSpreadsheet className="w-5 h-5 text-accent" />
      <span className="font-medium text-foreground min-w-[180px]">{label}</span>
      <a href={`${API_BASE}/kg/templates/${entityKey}`} className="inline-flex items-center gap-1 text-sm text-primary hover:underline" data-testid={`template-${entityKey}`}>
        <Download className="w-4 h-4" /> Template
      </a>
      <label className="inline-flex items-center gap-1 text-sm cursor-pointer bg-secondary hover:bg-secondary/80 transition-colors px-3 py-1.5 rounded-md" data-testid={`upload-${entityKey}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        Import CSV
        <input type="file" accept=".csv" className="hidden" disabled={busy}
          onChange={(e) => { doImport(e.target.files[0]); e.target.value = ""; }} />
      </label>
      {result && (
        <span className="text-xs text-muted-foreground ml-auto">
          +{result.created} created, {result.updated} updated
          {result.errors?.length > 0 && <span className="text-destructive"> · {result.errors.length} errors</span>}
        </span>
      )}
    </div>
  );
};

export const ImportPanel = ({ nodeTypeEntries }) => (
  <div>
    <h2 className="font-serif text-2xl text-foreground mb-1">Import seed data</h2>
    <p className="text-sm text-muted-foreground mb-5">
      Download a template, fill it in, and upload. List fields use <code className="bg-muted px-1 rounded">|</code> to separate values.
      Re-importing an entity with the same name updates it.
    </p>
    <div className="space-y-3">
      {nodeTypeEntries.map((nt) => <ImportRow key={nt.key} entityKey={nt.key} label={nt.label} />)}
      <ImportRow entityKey="relationships" label="Relationships (edges)" />
    </div>
  </div>
);
